import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, computed, watch } from "vue";
import OfferCard from "@/components/offers/offer/OfferCard.vue";
import { OfferSingle } from "@/services/offers/OfferSingle";
import KeyValueTable from "@/components-UI/table/KeyValueTable.vue";
import BaseLineLoader from "@/components-UI/BaseLineLoader.vue";
import { format } from 'date-fns';
import store from "@/store";
import { eventBus } from "@/eventbus";
import BaseDateTimePicker from "@/components-UI/BaseDateTimePicker.vue";
import { canEditOffers } from "@/utils/checkRole";


export default /*#__PURE__*/_defineComponent({
  __name: 'GoalPayoutAndRevenue',
  props: {
    offer: {
        required: true,
        type: OfferSingle,
    },
    goal: {
        required: true,
        type: Object,
    },
},
  setup(__props) {

const props = __props



const canEditOffer = computed(() => canEditOffers());

const currencies = computed(() => store.state['catalogueModule'].currencies );
const isEdit = ref(false);
const isLoading = ref(false);

const isActonDateChanged = ref(false);
const actionDate = ref(format(new Date(), 'yyyy-MM-dd HH:mm'));

const changeActionDate = (value) => {
    isActonDateChanged.value = true;
    actionDate.value = value;
};

const tableData = ref({
    revenue: {
        headers : ['Тип', 'Сумма'],
        items : [],
    },
    payout: {
        headers : ['Тип', 'Сумма', '%'],
        items : [],
    },
});

const selectsData = ref([
    { value: 'fixed', text: 'Фиксированная' },
    { value: 'percent', text: 'Процент' },
]);

const getCurrencySymbol = (type, currencyCode) => {
    if (type === 'percent') {
        return '%';
    } else {
        const currency = currencies.value.find(c => c.code === currencyCode);
        return currency ? currency.symbol : '';
    }
};

const collectData = () => {
    actionDate.value = format(new Date(), 'yyyy-MM-dd HH:mm');
    const percent = ((props.goal.payout.amount / props.goal.revenue.amount) * 100 || 0).toFixed(2);
    const isShowPercent = props.goal.revenue.type === 'fixed' && props.goal.payout.type === 'fixed';

    // revenue
    tableData.value.revenue.items = [
        {
            value: props.goal.revenue.type,
            isEditable: true,
            type: 'select',
        },
        {
            value: [
                props.goal.revenue.amount,
                getCurrencySymbol(props.goal.revenue.type, props.goal.revenue.currency),
            ],
            isEditable: true,
            type: 'fieldSuffix',
        },
    ];

    // payout
    tableData.value.payout.items = [
        {
            value: props.goal.payout.type,
            isEditable: true,
            type: 'select',
        },
        {
            value: [
                props.goal.payout.amount,
                getCurrencySymbol(props.goal.payout.type, props.goal.payout.currency),
            ],
            isEditable: true,
            type: 'fieldSuffix',
        },
        {
            value: percent,
            isEditable: true,
            type: 'fieldPercent',
            isShow: isShowPercent,
        },
    ];
};

const onUpdateItems = (tableKey, updatedItems) => {
    if( updatedItems.flag && updatedItems.flag === 'percent'){
        const percent = Number(updatedItems.tableItems.value[2].value);
        const revenueVal = Number(tableData.value['revenue'].items[1].value[0]);

        updatedItems.tableItems.value[1].value[0] = (( revenueVal / 100 ) * percent).toFixed(2);
        tableData.value[tableKey].items = updatedItems.tableItems;
    }else{
        updatedItems.value[1].value[1] = getCurrencySymbol(updatedItems.value[0].value, props.goal[tableKey].currency);
        tableData.value[tableKey].items = updatedItems;

        const payoutVal = Number( tableData.value.payout.items[1].value[0] );
        const revenueVal = Number( tableData.value.revenue.items[1].value[0] );
        const percent = (( payoutVal / revenueVal ) * 100).toFixed(2);
        const isShowPercent = tableData.value.payout.items[0].value === 'fixed' && tableData.value.revenue.items[0].value === 'fixed';

        tableData.value.payout.items[2].isShow = isShowPercent;
        tableData.value.payout.items[2].value = percent;
    }
};

const sendData = async() => {
    isLoading.value = true;

    const goalData = {
        revenue : {
            type : tableData.value.revenue.items[0].value,
            model : props.goal.revenue.model,
            amount : Number( tableData.value.revenue.items[1].value[0] ),
        },
        payout: {
            type : tableData.value.payout.items[0].value,
            model : props.goal.payout.model,
            amount : Number( tableData.value.payout.items[1].value[0] ),
        },
    };

    const data = { ...props.goal, ...goalData };
    if (isActonDateChanged.value) data.action_date = actionDate.value;
    const isOfferGoalDataSaved = await props.offer?.editGoal(data);
    if (isOfferGoalDataSaved) {
        eventBus.$emit("update-goal");
    }

    isLoading.value = false;
};

onBeforeMount(() => {
    collectData();
});

// onUpdate props.goal
watch(() => props.goal, () => collectData(), { deep: true, immediate: true });

// -- [ Card Methods ] --
const editInfo = (edit: boolean) => {
    isEdit.value = edit;

    if ( !edit ) {
        sendData();
    }
};
const cancelEdit = () => {
    isEdit.value = false;
    collectData();
};

return { __sfc: true,props, canEditOffer, currencies, isEdit, isLoading, isActonDateChanged, actionDate, changeActionDate, tableData, selectsData, getCurrencySymbol, collectData, onUpdateItems, sendData, editInfo, cancelEdit, OfferCard, KeyValueTable, BaseLineLoader, BaseDateTimePicker }
}

})